export const agoraObject = {
    localTracks: {
      videoTrack: null,
      audioTrack: null,
      screenTrack: null
    },
    remoteUser: null
}
